import React from "react";
import * as R from "ramda";
import { FormControl, MenuItem, Select } from "@mui/material";
import { SURFACE_UNITS } from "../../contants";
import styles from "./surfaceUnitSelector.module.scss";

function SurfaceUnitSelector({ surfaceUnit, setter = () => {} }) {
  const handleChange = (event) => {
    setter(event.target.value);
  };

  return (
    <div className={styles.mainContainer}>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 140 }}>
        <Select value={surfaceUnit} label="Age" onChange={handleChange}>
          {R.values(SURFACE_UNITS).map((c) => (
            <MenuItem value={c} key={c.label}>
              {c.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default SurfaceUnitSelector;
